 <template>
  <v-container>
    <v-card v-bind:style="styleObject">
      <div class="card-header" style="background-color: #1abc9c !important;">
        <h2 class="font-weight-regular">Semanggi Apps</h2>
      </div>
      <v-container style="margin-bottom:1rem;"> 
        <v-form @submit="validate" ref="form" v-model="valid" lazy-validation v-bind:style="{width:'325px'}">
          <v-text-field
            v-model="password" 
            label="Type new password"
            type="password"
            required
            :rules="passwordRules"
            v-on:keyup.enter="validate"
          ></v-text-field>
          <v-text-field
            v-model="password_conf"
            label="Re-type new password"
            type="password"
            required
            :rules="passwordConfRules"
            v-on:keyup.enter="validate"
          ></v-text-field>
          <v-btn
            :disabled="!valid"
            block
            x-large
            class="btn-change-password  mr-4 mt-4"
            style="background-color: #16a085 !important"
            @click="validate"
            >Change</v-btn
          >
        </v-form>
      </v-container>
    </v-card>
  </v-container>
</template>
<style scoped>
  .card-header {
    text-align:center;
    padding:1rem;
  }
  .card-header h2{
    margin:0;
    color:#fff;
  }
  .btn-change-password {
    color:#fff;
    padding:0;
    text-transform: capitalize !important;
    font-size:1.3rem
  }
</style>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      valid: true,
      styleObject: {
        margin: "1rem auto",
        borderRadius: '8px'
      },
      password: "",
      password_conf: "",
      passwordRules: [
        v => v.length > 5 || 'Password minimal 6 characters',
      ],
      passwordConfRules: [
        v => v.length > 5 || 'Password Confirmation minimal 6 characters',
      ]
    };
  },
  methods: {
    ...mapActions({
      changePassword: "user/changePasswordFromEmail"
    }),
    async validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        const payload = {
          token: this.$route.query.token,
          password: this.password,
          password_conf: this.password_conf
        }
        if(payload.password !== payload.password_conf) {
          return alert("Password didn't match!");
        }
        // console.log(payload);
        // return alert(JSON.stringify(payload))
        try {
          const response = await this.changePassword(payload);
          if (!response.data.success) {
            this.$notify({
                group: 'custom-notification',
                type: 'error',
                title: 'Oops!',
                text: response.data.message
            });
          } else {
            this.$router.push("/login");
            this.$notify({
                group: 'custom-notification',
                type: 'success',
                title: 'Success!',
                text: 'Successfully change password!'
            });
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
  }
};
</script>
